// The priority letter chip (`Chip(text: record.priority.rawValue, color: priority.colorHex, filled: true)`): A red,
// B orange, C amber, D blue, F gray, filled like iOS so the hottest stores stand out in a long list.

import { PRIORITY_COLORS, PRIORITY_TITLES, type Priority } from '@/contracts/enums';
import { PIN_GRAY } from '@/domain/records';
import { Chip, type ChipSize } from '@/ui';

export interface PriorityChipProps {
  priority: Priority;
  /** "A · Hot" instead of "A" (filters, legends, detail headers). */
  showTitle?: boolean;
  /** Tinted instead of filled (dense tables where a column of solid chips is loud). */
  tinted?: boolean;
  size?: ChipSize;
  className?: string;
}

export function PriorityChip({ priority, showTitle = false, tinted = false, size = 'sm', className }: PriorityChipProps) {
  const title = PRIORITY_TITLES[priority] ?? priority;
  return (
    <Chip
      color={PRIORITY_COLORS[priority] ?? PIN_GRAY}
      filled={!tinted}
      size={size}
      title={`Priority ${title}`}
      className={className}
    >
      <span className="sr-only">Priority </span>
      {showTitle ? title : priority}
    </Chip>
  );
}
